module.exports = __webpack_public_path__ + "img/Bronze.0d9db190.svg";